import { SizableText, styled } from 'tamagui';

const Paragraph = styled(SizableText, {
  tag: 'p',
  // @ts-ignore
  lineHeight: 'normal',
  fontSize: '$14',
  display: 'block',
});

export default Paragraph;
